module.exports = __webpack_public_path__ + "img/search.6ed3c8e9.png";